import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface MmkEmptyStateProps {
  title: string;
  subtitle?: string;
}

export const MmkEmptyState: React.FC<MmkEmptyStateProps> = ({ title, subtitle }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        gridColumn: "1 / -1",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 6,
        px: 3,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          textAlign: "center",
          mb: 1,
          color: theme.palette.text.primary,
        }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="body2"
          sx={{ color: theme.palette.text.secondary, textAlign: "center" }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};
